var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-top"},[_c('div',{staticClass:"d-flex sidebar-top flex-column align-items-center py-2"},[_c('SwLogo'),_c('div',{staticClass:"sidebar-top__title"},[_vm._v("Manager - "+_vm._s(_vm.appVersion))])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }